
import  React from "react"
import { useRef, useEffect } from "react"
import { Play } from "lucide-react"

const VideoSection = () => {
  // Video ref
  const videoRef = useRef(null)

  // Autoplay video when in viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && videoRef.current) {
            videoRef.current.play().catch((error) => {
            })
          } else if (videoRef.current) {
            videoRef.current.pause()
          }
        })
      },
      { threshold: 0.5 },
    )

    if (videoRef.current) {
      observer.observe(videoRef.current)
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current)
      }
    }
  }, [])

  return (
    <section className="bg-gradient-to-r from-[#f0f8ff] to-[#fff8e1] py-16">
      <div className="container mx-auto px-4 text-center">
        <div className="mb-8 max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold mb-2 text-[#0072bc]">See Us In Action</h2>
          <p className="text-gray-600">Watch how our professionals deliver exceptional service</p>
        </div>

        <div className="relative mx-auto max-w-4xl overflow-hidden rounded-lg shadow-xl">
          <video
            ref={videoRef}
            className="w-full aspect-video object-cover"
            src="https://cdn.coverr.co/videos/coverr-a-plumber-fixing-a-sink-2812/1080p.mp4"
            poster="https://images.unsplash.com/photo-1574359411659-15573a27d625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"
            muted
            loop
            playsInline
            controls
          >
            Your browser does not support the video tag.
          </video>
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="bg-white/80 p-4 rounded-full opacity-0 transition-opacity group-hover:opacity-100">
              <Play className="h-8 w-8 text-[#0072bc]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default VideoSection